
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipping/[shipping]",
      function () {
        return require("private-next-pages/shipping/[shipping].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipping/[shipping]"])
      });
    }
  